import type { ChartContext } from '../../chart-models/context';

@Proxify
export class BaseChartProperty<UIData extends object = object> {
    public constructor(protected uiData: UIData, protected context: ChartContext) {}

    public init(...args: any) {
        return this;
    }
}

function Proxify<T extends new(...args: any[]) => {}>(constructor: T): T {
    return class extends constructor {
        public constructor(...args: any) {
            super(...args);
            return new Proxy(this, {
                get(target, key) {
                    if (key in target) {
                        return target[key];
                    }

                    // 未在property实例声明的属性，尝试从data上读取，实现类似自动声明proxyProperty的逻辑
                    return (target as any).uiData?.[key];
                },
            });
        }
    };
}
